$(document).ready(function(){
	$("dt").click(function(){ // trigger 
		$(this).next("dd").slideToggle("fast"); // blendet beim Klick auf "dt" die n�chste "dd" ein. 
		$(this).children("a").toggleClass("closed open"); // wechselt beim Klick auf "dt" die Klasse des enthaltenen a-Tags von "closed" zu "open". 
	});
});
